<template>
  <div class="d-flex content-center backgorund-c">
    <CRow>
      <CAlert 
        @update:show="(value)=> alertEvent(value)"
        class="w-50 mx-auto mt-5 fixed-top"
        :color="alert.color" :closeButton="typeof(alert.show)!=='number'" :show.sync="alert.show">
        {{alert.message}}   
        <CProgress
          v-if="typeof(alert.show)=='number'"
          :max="5"
          :value="alert.show"
          height="3px"
          :color="alert.color"
          animate
          class="my-3"
        />         
      </CAlert>
      <CCol>
        <CCardGroup>
          <CCard class="p-4 rounded shadow-sm">
            <div class="mx-auto mt-n5"> 
              <img src="../../public/static/logo_Optimo_ovalo.png" alt="logo Optimo" class="w-100 h-100">
            </div>
            <CForm class="" v-on:keyup.enter="!validate ? attempLogin() : ''">
              <!-- <h3 class="text-muted">&Oacute;ptimo</h3> -->
                <CInput
                  placeholder="Usuario"
                  autocomplete="user"
                  :value.sync="userEmail">
                  <template #prepend-content>
                    <CIcon name="cil-user"/>
                  </template>
                </CInput>
                <CInput
                  placeholder="Contraseña"
                  type="password"
                  autocomplete="curent-password"
                  :value.sync="psswrd">
                  <template #prepend-content>
                    <CIcon name="cil-lock-locked"/>
                  </template>
                </CInput>
                <CRow>
                  <CCol col="sm-12" class="text-right" @click="showModal=true">
                    <a href="#" class="text-muted ">
                      Recuperar contrase&ntilde;a
                    </a>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol col="sm-12" class="mt-2">
                    <CButton 
                      color="primary" 
                      class="col-sm-12"
                      :disabled="validate"
                      :class="validate ? 'disabled' : ''"
                      @click="attempLogin()">
                      <i class="bi bi-box-arrow-in-right mr-2"></i>
                      Inicia Sesi&oacute;n
                    </CButton>
                  </CCol>
                </CRow>
            </CForm>
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>
    <CModal
      color="dark"
      title="Recuperacion de contraseña"
      :show.sync="showModal"
      :centered="true"
      :closeOnBackdrop="false"
      :backdrop="true">
      <template v-slot:body-wrapper>
        <CRow>
          <CCol col="sm-12">

          </CCol>
        </CRow>
        <CContainer class="text-left mt-4 mb-2">
          <CInput
            label="Usuario registrado"
            placeholder="Usuario"
            autocomplete="user"
            :value.sync="userEmail">
            <template #prepend-content>
              <CIcon name="cil-user"/>
            </template>
          </CInput>
          <p>
            Se enviaran las instruciones para recuperar la contraseña del usuario al correo electronico registrado.
          </p>
        </CContainer>
      </template>
      <template v-slot:footer>
        <CContainer class="text-center">
          <CButton
            color="success"
            square 
            class="mr-2 d-inline-block"
            @click="recoveryPassword()">
            Solicitar
          </CButton>
        </CContainer>
      </template>
    </CModal>
    <CElementCover v-show="loading"/>
  </div>
</template>

<style scoped>
  .backgorund-c{
    background-image: url('../../public/static/img/background/04_bastien-nvs.jpg');
    background-repeat:no-repeat;
    background-size:cover,contain;
    background-position: center;
    background-attachment: fixed;
    height: 100%;
    animation: slide 120s infinite;
  }

  @keyframes slide {
    0% {
      background-image: url('../../public/static/img/background/04_bastien-nvs.jpg');
    }
    11.11% {
      background-image: url('../../public/static/img/background/05_bastien-nvs.jpg');
    }
    22.22% {
      background-image: url('../../public/static/img/background/06_bastien-nvs.jpg');
    }
    33.33% {
      background-image: url('../../public/static/img/background/07_carlos-ibanez.jpg');
    }
    44.44% {
      background-image: url('../../public/static/img/background/08_lawless-capture.jpg');
    }
    55.55% {
      background-image: url('../../public/static/img/background/10_mak.jpg');
    }
    66.66% {
      background-image: url('../../public/static/img/background/12_mathias-p-r-reding.jpg');
    }
    77.77% {
      background-image: url('../../public/static/img/background/13_mathias-p-r-reding.jpg');
    }
    88.88% {
      background-image: url('../../public/static/img/background/14_ryan-ancill.jpg');
    }
  }
</style>

<script>
  import moment from 'moment'
  import { 
    getKey, 
    dataUsuarioSession,
    grabaAccesoUsuario,
    actualizaSesionUsuario,
    solicitaClaveUsuario
  } from '../api'
  import {
    errorMessage,
    getRoutesModel,
    user_uid
  } from '../general'
  // import routesModel from '../router/routes-model.json'
  // import routesModel from '../router/routes-model-only-trackingdocs.json'

  export default {
    name: 'Login',
    data() {
      return {
        loading: false,
        userEmail: '',
        psswrd: '',
        backgroundImage: '',        
        showModal: false,
        modalMessage: '',
      }
    },
    methods: {
      async attempLogin(){
        this.loading = true;

        try {
          try {
            const { token, refresh } = await getKey(this.userEmail, this.psswrd);
            await grabaAccesoUsuario(this, this.userEmail, true);

            this.$store.commit('setUserValue', ['token', token]);
            this.$store.commit('setUserValue', ['tokenRefresh', refresh]);
            this.$store.commit('setUserValue', ['isLoggedIn', true]);
            this.$store.commit('setUserValue', ['logginDate', moment().format()]);

            const { response } = await dataUsuarioSession(this, token);
            const userData = response;

            this.$store.commit('setUserValue', ['type', userData.tipo_Usuario[0]]);

            if (this.$store.state.user.type === 'E') {
              await this.updateSessionStatus(
                async () => {
                  // Carga el modelo de rutas que tiene acceso el usuario
                  const routesModel = await getRoutesModel();

                  this.$store.commit(
                    'setUserValue', 
                    [
                      'data', 
                      {
                        ...userData,
                        routesAccessModel: routesModel
                      }
                    ]
                  )
                  
                  this.$router.push({path: routesModel[0].children[0].path })

                  this.loading = false
                }
              )
            } else {
              const routesModel = await getRoutesModel();

              this.$store.commit(
                'setUserValue', 
                [
                  'data', 
                  {
                    ...userData,
                    routesAccessModel: routesModel
                  }
                ]
              )
              
              this.$router.push({path: routesModel[0].children[0].path })
            }
          } catch (error) {
            await grabaAccesoUsuario(this, this.userEmail, false)

            const message = {...error}.response.data.non_field_errors ? {...error}.response.data.non_field_errors[0] : 'Error al cargar datos'

            this.$store.commit(
              'setAlert',
              { 
                color: 'danger',
                message: message,
                show: 5 
              }
            )
          } finally {
            this.loading = false;
          }
        } catch(err) {
          this.setAlert(false)
        } finally {
          this.loading = false
        }
      },
      async updateSessionStatus(continuation) {
        try{
          await actualizaSesionUsuario(
            this,
            user_uid(), 
            'A'
          )
          continuation()
        } catch(error) {
          this.$store.commit('setAlert', {
            color: 'danger',
            message: errorMessage(error.response),
            show: 5
          })
        }
      },
      async recoveryPassword() {
        try {
          this.loading = true

          await solicitaClaveUsuario(this.userEmail)
        } catch(error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Ocurrio un error en la recuperacion de contraseña.",
            show: 5
          })
        } finally {
          this.loading = false
          this.showModal = false
        }
      },
      alertEvent(value){
        if (typeof(value) == 'boolean') {    
          this.$store.commit('setAlert',{ show: false })
        } else {
          // console.log(value)
          if (!value) {
            this.$store.commit('setAlert',{ show: false })
          }
        }
      },
      setAlert(value){
        this.$store.commit(
          'setAlert',
          { 
            color: value ? 'success' : 'danger',
            message: value ?'Acción exitosa':'No se pudo iniciar sesión',
            show: 5 
          }
        )
      },
      getImagesList() {
        return require.context('../../public/static/img/background', true, /\.jpg$/)
      },
      setImageBackground(){
        const images = this.getImagesList()
        const randomValue = Math.floor(Math.random() * images.keys().length)
        this.backgroundImage = images(images.keys()[randomValue])
      },
      //async checkSessionStatus() {
      //  try {
      //    await validaSesionUsuario(
      //      this,
      //      user_uid()
      //    )
      //  } catch(error) {
      //    //console.log(error.response.status)
      //    if(error.response.status != 401){
      //      return 
      //    }
//
      //    this.showModal = true
      //    this.modalMessage = errorMessage(error.response)
      //  }
      //}
    },
    computed:{
      alert(){
        return this.$store.state.alert
      },
      validate(){
        return (this.psswrd.length==0)||(this.userEmail.length==0)
      }
    },
    mounted() {
      // this.$forceUpdate()
    }
  }
</script>